
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/whats-in-my-region",
      function () {
        return require("private-next-pages/[locale]/whats-in-my-region/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/whats-in-my-region"])
      });
    }
  